import { deriveFullCustomizationsFromConfig, GenericPriceSummary, PriceSummaryProps } from './GenericPriceSummary';
import React from 'react';
import { usePriceSummaryController } from './PriceSummary.controller';
import { PRICE_CONFIG } from '@apps/card/constants/price';

const LegacyPriceSummary: React.FC<PriceSummaryProps> = ({ ...restProps }) => {
  const { priceUpTo, cardConfig, salesTax, promotion, templateCategory, cardSize } = restProps;
  //   const { activeProduct, priceCalculator, attributeStates } = useStationeryProductPricingContext();
  //   useRegisterAttributeLinks(attributeStates.addAttribute, activeProduct);
  //   const { getFullState } = attributeStates;
  //   const options = getFullState(cardConfig);
  //   const shouldShowShipping = priceUpTo === 'total';

  const summary = usePriceSummaryController(templateCategory, priceUpTo, PRICE_CONFIG, deriveFullCustomizationsFromConfig(cardConfig), promotion, salesTax, cardSize);

  return (
    <GenericPriceSummary
      {...restProps}
      summary={summary}
    />
  );
};

export default LegacyPriceSummary;
